import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnCard as CnCardView } from './cn-card';
export var CnCard = withI18n(CnCardView, { locale: locale });
export * from './types/main';
